/* card-interactions.js — previously intercepted the first tap on a product card (touch devices only)
   to reveal the secondary product image instead of navigating, requiring a second tap to actually open
   the product page. That "quick look" tap behavior is now DISABLED by explicit request: on mobile, a
   single tap should open the product page immediately, with no secondary-image reveal step at all.

   Desktop is completely unaffected either way — it never used this file. Desktop's hover-to-second-image
   behavior lives entirely in separate, untouched CSS (theme.css.liquid for base cards,
   premium-bestsellers.liquid's own <style> for that section) driven by real mouse :hover, nothing here.

   The listener below is kept (rather than deleting the file) purely as a documented no-op, in case this
   behavior is ever wanted back — it never calls preventDefault() or touches any class, so every tap now
   just falls through to the link's own default navigation.
*/
(function () {
  var IMAGE_LINK_SELECTOR = '.grid-product__link, [data-pbs-card] .pbs-card-image > a';

  function isTouch() {
    return window.matchMedia('(hover: none)').matches;
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!isTouch()) return;
      if (!e.target.closest(IMAGE_LINK_SELECTOR)) return;
      // Intentionally does nothing — first tap now navigates immediately, exactly like a normal link.
    },
    true
  );
})();
